export interface ThrottledFunction {
  (): void;
  cancel: () => void;
}

export const throttle = (fn: () => void, wait: number): ThrottledFunction => {
  let lastInvokeTime = 0;
  let timeoutId: ReturnType<typeof setTimeout> | null = null;

  const cancel = () => {
    if (timeoutId !== null) {
      clearTimeout(timeoutId);
      timeoutId = null;
    }
    lastInvokeTime = 0;
  };

  const throttled = () => {
    const now = Date.now();
    const remaining = wait - (now - lastInvokeTime);

    if (remaining <= 0) {
      if (timeoutId !== null) {
        clearTimeout(timeoutId);
        timeoutId = null;
      }
      lastInvokeTime = now;
      fn();
    } else if (timeoutId === null) {
      timeoutId = setTimeout(() => {
        timeoutId = null;
        lastInvokeTime = Date.now();
        fn();
      }, remaining);
    }
  };

  throttled.cancel = cancel;
  return throttled;
};
